import { AttributeFilterItemProps } from "../../../common/interfaces";
import React, { useContext } from "react";

import { AttributeFilterOptionItem } from "./AttributeFilterOptionItem";
import { FilterContext } from "../../FilterContext";
import { compareAttributeFilterOptions } from "../../../common/util";

export const AttributeFilterItemCheckboxList: React.FC<AttributeFilterItemProps> = ({ attributeFilter }) => {
  const { appliedAttributeFilters, applyAttributeFilter } = useContext(FilterContext);
  const appliedAttributeFilter = appliedAttributeFilters.find(filter => filter.code === attributeFilter.code);
  const currentAppliedOptions = (appliedAttributeFilter && appliedAttributeFilter.options) || [];
  const sortedAvailableOptions = [...attributeFilter.options].sort(compareAttributeFilterOptions);

  const attributeFilterItemOptions = () => {
    return sortedAvailableOptions.map(option => {
      const isActive = !!currentAppliedOptions.find(opt => opt.label === option.label);
      const onSelected = () => {
        applyAttributeFilter({
          ...attributeFilter,
          options: isActive
            ? currentAppliedOptions.filter(opt => opt.label !== option.label)
            : [...currentAppliedOptions, option]
        });
      };

      return (
        <AttributeFilterOptionItem
          attributeFilterId={attributeFilter.code}
          key={option.value}
          attributeFilterOption={option}
          active={isActive}
          onSelected={onSelected}
        />
      );
    });
  };

  return <ul className="attribute-filter-accordion__attribute-options">{attributeFilterItemOptions()}</ul>;
};
